import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'
import App from './containers/app'

import 'sanitize.css/sanitize.css'
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './index.css'
import './css/animate.min.css'
import './css/balloon.css'
import './css/introjs.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const target = document.querySelector('#root');

const renderApp = () => {
    render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <div>
                    <App/>
                </div>
            </ConnectedRouter>
        </Provider>,
        target
    )
};

renderApp();
